/* ==========================================================================
   FRØYA GOURMET — Levering (v10.1, 31.10.2026)

   v10.1: pekefinger (👇 i hjelpeboksen, 👉 ved postnummerfeltet) som viser hva kunden skal gjøre.

   v10 TRE VALG: «Utlevering Midt-Norge», «Utlevering Østlandet» og
   «Hjemlevering Trondheim». Valget skrives til handlekurv-attributtet
   «Leveringsmåte» med verdiene fra seksjonen (data-mode-midt / data-mode-ost,
   standard «Utlevering Midt-Norge» / «Utlevering Østlandet») eller
   «Hjemlevering». Shipfy-appen leser attributtet og viser i kassen bare
   fraktvalgene som hører til:
     Midt-Norge  → bare «Utlevering: <sted>»
     Østlandet   → bare «Utlevering Østlandet: <sted>»
     Hjemlevering→ bare «Hjemlevering – sendes fryst»
   Hvert utleveringskort åpner bare sin egen landsdel sitt stedspanel.
   Gamle handlekurver med verdien «Utlevering» (uten landsdel) nullstilles,
   så kunden må velge landsdel på nytt.

   v9.2 stedene i handlekurven er kun visning — selve stedet velges i kassen.
   v9 postnummersperre for Hjemlevering (HJEM_POSTNUMRE under).

   Valgkort har data-tilstand: '' = ikke valgt, 'aapen' = åpnet men ikke
   ferdig (kun Hjemlevering: venter på postnummer), 'valgt' = valgt.
   ========================================================================== */
(function () {
  'use strict';

  /* ---- Hjemlevering: tillatte postnumre (Trondheim med omegn) --------------
     7010–7020 sentrum, 7021–7061 Trondheim/Ranheim/Jonsvatnet/Jakobsli/Klæbu,
     7066–7069, 7071–7072, 7075, 7078–7082, 7088–7089, 7091–7093, 7097–7098.
     (Ikke med: 7070 Bosberg, 7074 Spongdal, 7083 Leinstrand, 7099 Flatåsen,
     74xx.) */
  var HJEM_POSTNUMRE = '7010-7061, 7066-7069, 7071-7072, 7075, 7078-7082, 7088-7089, 7091-7093, 7097-7098';

  var POST_REGLER = (function (tekst) {
    var ut = [];
    String(tekst || '').split(',').forEach(function (del) {
      var m = del.replace(/\s+/g, '').match(/^(\d{4})(?:-(\d{4}))?$/);
      if (!m) return;
      var fra = Number(m[1]);
      var til = m[2] ? Number(m[2]) : fra;
      if (til >= fra) ut.push([fra, til]);
    });
    return ut;
  })(HJEM_POSTNUMRE);

  function renPost(s) {
    var m = String(s == null ? '' : s).replace(/\s+/g, '').match(/^(?:NO-?)?(\d{4})$/i);
    return m ? m[1] : '';
  }

  function postOk(s) {
    if (!POST_REGLER.length) return true;
    var p = renPost(s);
    if (!p) return false;
    var n = Number(p);
    for (var i = 0; i < POST_REGLER.length; i++) {
      if (n >= POST_REGLER[i][0] && n <= POST_REGLER[i][1]) return true;
    }
    return false;
  }

  var ATTR = {
    mode: 'Leveringsmåte',
    sted: 'Utleveringssted',
    dato: 'Neste utlevering',
    rate: 'Fraktvalg i kasse',
    post: 'Postnummer'
  };

  var HJEM = 'Hjemlevering';
  /* Overskrives fra seksjonen i start(). */
  var MODE = { midt: 'Utlevering Midt-Norge', ost: 'Utlevering Østlandet' };

  var LAGER = 'fg-levering';
  var LAGER_POST = 'fg-levering-sist-post';

  var UKEDAGER = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];
  var MAANEDER = ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli',
                  'august', 'september', 'oktober', 'november', 'desember'];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Hvilken landsdel en Leveringsmåte-verdi gjelder: 'midt', 'ost' eller ''. */
  function landsdelFor(mode) {
    if (!mode) return '';
    if (mode === MODE.ost) return 'ost';
    if (mode === MODE.midt) return 'midt';
    return '';
  }
  function erUtlevering(mode) { return landsdelFor(mode) !== ''; }

  function formaterDato(d) {
    return UKEDAGER[d.getDay()] + ' ' + d.getDate() + '. ' + MAANEDER[d.getMonth()];
  }

  function rytme(d, intervall) {
    var dag = UKEDAGER[d.getDay()];
    var uker = Number(intervall) > 0 ? Number(intervall) : 1;
    if (uker === 1) return 'Hver ' + dag;
    if (uker === 2) return 'Annenhver ' + dag;
    return 'Hver ' + uker + '. uke, ' + dag;
  }

  function nesteDato(anker, intervall) {
    if (!anker) return null;
    var deler = anker.split('-');
    if (deler.length !== 3) return null;
    var d = new Date(Number(deler[0]), Number(deler[1]) - 1, Number(deler[2]));
    if (isNaN(d.getTime())) return null;
    var uker = Number(intervall) > 0 ? Number(intervall) : 1;
    var idag = new Date();
    idag.setHours(0, 0, 0, 0);
    var vakt = 0;
    while (d < idag && vakt < 500) {
      d.setDate(d.getDate() + uker * 7);
      vakt++;
    }
    return d;
  }

  function lagre(data) {
    try { localStorage.setItem(LAGER, JSON.stringify(data)); } catch (e) { /* privat modus */ }
  }
  function hent() {
    try { return JSON.parse(localStorage.getItem(LAGER) || 'null'); } catch (e) { return null; }
  }
  function glem() {
    try { localStorage.removeItem(LAGER); } catch (e) { /* privat modus */ }
  }

  var sistPostMinne = '';
  function lagreSistPost(p) {
    sistPostMinne = p || '';
    try { localStorage.setItem(LAGER_POST, sistPostMinne); } catch (e) { /* privat modus */ }
  }
  function hentSistPost() {
    if (sistPostMinne) return sistPostMinne;
    try { return localStorage.getItem(LAGER_POST) || ''; } catch (e) { return ''; }
  }

  function skrivTilKurv(attributter) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributter })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/update ' + r.status);
      return r.json();
    });
  }

  function tomKurvValg() {
    var tom = {};
    tom[ATTR.mode] = ''; tom[ATTR.sted] = ''; tom[ATTR.dato] = ''; tom[ATTR.rate] = ''; tom[ATTR.post] = '';
    return skrivTilKurv(tom).catch(function () {});
  }

  function gyldig(v) {
    if (!v) return false;
    if (v.mode === HJEM) return postOk(v.post);
    return erUtlevering(v.mode);
  }

  function oppdaterMerker(valg) {
    var merker = document.querySelectorAll('[data-fg-lev-merke]');
    for (var i = 0; i < merker.length; i++) {
      var verdi = merker[i].querySelector('[data-fg-lev-merke-verdi]') || merker[i];
      if (gyldig(valg)) {
        verdi.textContent = valg.mode;
        merker[i].setAttribute('data-tom', 'false');
      } else {
        verdi.textContent = 'Ikke valgt';
        merker[i].setAttribute('data-tom', 'true');
      }
    }
  }

  var krever = false;

  function harValg() { return gyldig(hent()); }

  function sperreKasse(e) {
    if (!krever || harValg()) return;
    var maal = e.target.closest
      ? e.target.closest('[name="checkout"], a[href*="/checkout"], .shopify-payment-button button')
      : null;
    if (!maal) return;
    var rot = document.querySelector('[data-fg-levering]');
    if (!rot) return;
    e.preventDefault();
    e.stopPropagation();
    var status = rot.querySelector('[data-fg-lev-status]');
    var hjemKort = rot.querySelector('[data-fg-lev-hjem]');
    var hjemAapen = !!(hjemKort && hjemKort.getAttribute('data-tilstand') === 'aapen');
    if (status) {
      status.className = 'fg-lev__status fg-lev__status--topp fg-lev__status--advarsel';
      status.innerHTML = hjemAapen
        ? '<b>Skriv inn postnummeret ditt først</b> for å bruke Hjemlevering, eller velg utlevering.'
        : '<b>Velg hvordan du vil få varene først:</b> ' + esc(MODE.midt) + ', ' + esc(MODE.ost) + ' eller Hjemlevering.';
    }
    rot.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function injiserStil() {
    if (document.getElementById('fg-lev-post-stil')) return;
    var s = document.createElement('style');
    s.id = 'fg-lev-post-stil';
    s.textContent =
      '.fg-lev .fg-lev__post{max-width:46rem;margin:0 0 1.25rem;padding:1.5rem 1.6rem 1.6rem;background:#fff;border:2px solid var(--fg-dyphav,#0A1C24);border-left:8px solid var(--fg-oljehyre,#F2B01E);box-shadow:4px 4px 0 var(--fg-oljehyre,#F2B01E);font-family:var(--fg-body,sans-serif);color:var(--fg-dyphav,#0A1C24)}' +
      '.fg-lev .fg-lev__post[hidden]{display:none}' +
      '.fg-lev .fg-lev__post-tittel{margin:0 0 .35rem;font-family:var(--fg-display,"Bricolage Grotesque",var(--fg-body,sans-serif));font-weight:800;font-size:clamp(1.5rem,4.6vw,2.1rem);line-height:1.1;letter-spacing:.01em;text-transform:uppercase}' +
      '.fg-lev .fg-lev__post-label{display:block;margin:0 0 .85rem;font-size:1.05rem;line-height:1.45;color:rgba(10,28,36,.8)}' +
      '.fg-lev .fg-lev__post-rad{display:flex;gap:.7rem;flex-wrap:wrap;align-items:center}' +
      '.fg-lev .fg-lev__post-felt{flex:1 1 10rem;max-width:15rem;min-width:0;padding:1rem 1.1rem;font:inherit;font-size:1.6rem;font-weight:600;letter-spacing:.14em;border:2px solid var(--fg-dyphav,#0A1C24);border-radius:0;background:#fff;color:inherit}' +
      '.fg-lev .fg-lev__post-felt:focus-visible{outline:3px solid var(--fg-oljehyre,#F2B01E);outline-offset:2px}' +
      '.fg-lev .fg-lev__post-knapp,.fg-lev .fg-lev__post-bytt{padding:1rem 1.6rem;font-family:var(--fg-mono,monospace);font-size:.9rem;font-weight:700;letter-spacing:.14em;text-transform:uppercase;border:2px solid var(--fg-dyphav,#0A1C24);border-radius:0;cursor:pointer}' +
      '.fg-lev .fg-lev__post-knapp{background:var(--fg-oljehyre,#F2B01E);color:var(--fg-dyphav,#0A1C24);box-shadow:3px 3px 0 var(--fg-dyphav,#0A1C24)}' +
      '.fg-lev .fg-lev__post-knapp:focus-visible,.fg-lev .fg-lev__post-bytt:focus-visible{outline:3px solid var(--fg-oljehyre,#F2B01E);outline-offset:2px}' +
      '.fg-lev .fg-lev__post-bytt{margin-top:.9rem;background:#fff;color:var(--fg-dyphav,#0A1C24)}' +
      '.fg-lev .fg-lev__post-bytt[hidden]{display:none}' +
      '.fg-lev .fg-lev__post-melding{margin:.9rem 0 0;font-size:1.1rem;line-height:1.5}' +
      '.fg-lev .fg-lev__post-melding:empty{display:none}' +
      '.fg-lev .fg-lev__post-melding[data-type="feil"]{color:#9B1C1C;font-weight:600}' +
      '.fg-lev .fg-lev__post-melding[data-type="ok"]{color:var(--fg-strom,#12414E);font-weight:700}' +
      /* Pekefingre */
      '.fg-lev .fg-lev__status--finger{display:flex;align-items:center;gap:1rem}' +
      '.fg-lev .fg-lev__finger{flex:none;font-size:2.6rem;line-height:1;display:inline-block;animation:fg-lev-pek-ned 1.1s ease-in-out infinite}' +
      '.fg-lev .fg-lev__finger--hoyre{font-size:2.4rem;animation-name:fg-lev-pek-hoyre}' +
      '@keyframes fg-lev-pek-ned{0%,100%{transform:translateY(-.15rem)}50%{transform:translateY(.55rem)}}' +
      '@keyframes fg-lev-pek-hoyre{0%,100%{transform:translateX(-.2rem)}50%{transform:translateX(.5rem)}}' +
      '@media (prefers-reduced-motion:reduce){.fg-lev .fg-lev__finger{animation:none}}' +
      '@media (max-width:749px){.fg-lev .fg-lev__post{padding:1.2rem 1.1rem 1.3rem}.fg-lev .fg-lev__post-felt{max-width:none;flex:1 1 8rem}.fg-lev .fg-lev__post-knapp{flex:1 1 auto}.fg-lev .fg-lev__finger--hoyre{display:none}.fg-lev .fg-lev__finger{font-size:2.2rem}}';
    document.head.appendChild(s);
  }

  function start(rot) {
    krever = rot.getAttribute('data-require') === 'true';
    MODE.midt = rot.getAttribute('data-mode-midt') || MODE.midt;
    MODE.ost = rot.getAttribute('data-mode-ost') || MODE.ost;

    var status = rot.querySelector('[data-fg-lev-status]');
    var guide = rot.querySelector('[data-fg-lev-guide]');
    var kortHjem = rot.querySelector('[data-fg-lev-hjem]');
    var kortUt = {};
    var paneler = {};
    var k = rot.querySelectorAll('[data-fg-lev-mode="utlevering"][data-landsdel]');
    for (var a = 0; a < k.length; a++) kortUt[k[a].getAttribute('data-landsdel')] = k[a];
    var p = rot.querySelectorAll('[data-fg-lev-panel="utlevering"][data-landsdel]');
    for (var b = 0; b < p.length; b++) paneler[p[b].getAttribute('data-landsdel')] = p[b];
    var knapper = rot.querySelectorAll('[data-fg-lev-sted]');
    var harUt = !!(kortUt.midt || kortUt.ost);

    var hjemPanel = null;
    var postFelt = null;
    var postMelding = null;
    var postBytt = null;

    /* Rytme («Annenhver tirsdag · 17:30–18:00») og neste dato per sted. */
    for (var i = 0; i < knapper.length; i++) {
      var tid = knapper[i].getAttribute('data-tid') || '';
      var intervall = knapper[i].getAttribute('data-intervall');
      var d = nesteDato(knapper[i].getAttribute('data-anker'), intervall);
      var rytmeFelt = knapper[i].querySelector('[data-fg-lev-rytme]');
      if (rytmeFelt) {
        var linje = d ? rytme(d, intervall) : '';
        if (tid) linje = linje ? linje + ' · ' + tid : tid;
        rytmeFelt.textContent = linje;
      }
      if (!d) continue;
      var nesteFelt = knapper[i].querySelector('[data-fg-lev-neste]');
      if (nesteFelt) nesteFelt.textContent = 'Neste: ' + formaterDato(d);
    }

    function settKort(kort, tilstand) {
      if (!kort) return;
      kort.setAttribute('data-tilstand', tilstand);
      kort.setAttribute('aria-checked', String(tilstand === 'valgt'));
    }

    function settPostMelding(type, tekst, visBytt) {
      if (!postMelding) return;
      postMelding.setAttribute('data-type', type || '');
      postMelding.textContent = tekst || '';
      if (postBytt) postBytt.hidden = !visBytt;
    }

    function visStatus(valg, hjemAapen) {
      if (!status) return;
      if (valg && valg.mode === HJEM) {
        var pris = kortHjem ? kortHjem.getAttribute('data-pris') : '';
        status.className = 'fg-lev__status fg-lev__status--topp fg-lev__status--ok';
        status.innerHTML =
          '<span class="fg-lev__status-hake" aria-hidden="true">✓</span>' +
          '<span>Du har valgt <span class="fg-lev__status-mode">Hjemlevering</span> — varene sendes fryst hjem til deg' +
          (pris ? ' (' + esc(pris) + ')' : '') + '.' +
          '<span class="fg-lev__status-kasse">I kassen vises bare «' + esc(valg.rate) + '».</span></span>';
        return;
      }
      var ld = valg ? landsdelFor(valg.mode) : '';
      if (ld) {
        status.className = 'fg-lev__status fg-lev__status--topp fg-lev__status--ok';
        status.innerHTML =
          '<span class="fg-lev__status-hake" aria-hidden="true">✓</span>' +
          '<span>Du har valgt <span class="fg-lev__status-mode">' + esc(valg.mode) + '</span> — du henter selv, gratis.</span>';
        return;
      }
      if (hjemAapen) {
        status.className = 'fg-lev__status fg-lev__status--topp fg-lev__status--hint fg-lev__status--finger';
        status.innerHTML = '<span class="fg-lev__finger" aria-hidden="true">👇</span>' +
          '<span><b>Hjemlevering:</b> skriv inn postnummeret ditt i boksen under, så sjekker vi at vi kjører hjem til deg.</span>';
        return;
      }
      status.className = 'fg-lev__status fg-lev__status--topp fg-lev__status--hint';
      var deler = [];
      if (kortUt.midt) deler.push('<b>' + esc(MODE.midt) + '</b>');
      if (kortUt.ost) deler.push('<b>' + esc(MODE.ost) + '</b>');
      if (kortHjem) deler.push('<b>Hjemlevering</b>');
      status.innerHTML = 'Velg ' + (deler.length > 1 ? deler.slice(0, -1).join(', ') + ' eller ' + deler[deler.length - 1] : deler.join('')) + '.';
    }

    /* Tegn hele komponenten ut fra én tilstand. */
    function tegn(valg, hjemAapen) {
      var erHjem = !!(valg && valg.mode === HJEM);
      var ld = valg ? landsdelFor(valg.mode) : '';
      var hjemApen = !!hjemAapen && !erHjem && !ld;
      settKort(kortHjem, erHjem ? 'valgt' : (hjemApen ? 'aapen' : ''));
      settKort(kortUt.midt, ld === 'midt' ? 'valgt' : '');
      settKort(kortUt.ost, ld === 'ost' ? 'valgt' : '');
      if (paneler.midt) paneler.midt.hidden = ld !== 'midt';
      if (paneler.ost) paneler.ost.hidden = ld !== 'ost';
      if (guide) guide.style.display = ld ? '' : 'none';
      if (hjemPanel) hjemPanel.hidden = !(erHjem || hjemApen);
      if (erHjem && valg.post) settPostMelding('ok', '✓ Ja, vi leverer til ' + valg.post + '.', false);
      visStatus(valg, hjemApen);
      oppdaterMerker(valg);
    }

    function lagreValg(valg, kunLokal) {
      lagre(valg);
      if (kunLokal) return;
      var attributter = {};
      attributter[ATTR.mode] = valg.mode;
      attributter[ATTR.sted] = '';
      attributter[ATTR.dato] = '';
      attributter[ATTR.rate] = valg.rate || '';
      attributter[ATTR.post] = valg.post || '';
      skrivTilKurv(attributter).catch(function () {
        if (!status) return;
        status.className = 'fg-lev__status fg-lev__status--topp fg-lev__status--advarsel';
        status.innerHTML = '<b>Kunne ikke lagre valget.</b> Prøv igjen, eller oppdater siden.';
      });
    }

    /* Utlevering i en landsdel — stedet velges i kassen. */
    function velgUtlevering(ld, skrivKurv) {
      var valg = { mode: MODE[ld], sted: '', dato: '', rate: '', post: '' };
      tegn(valg, false);
      settPostMelding('', '');
      lagreValg(valg, !skrivKurv);
    }

    function velgHjem(post) {
      var valg = { mode: HJEM, sted: '', dato: '', rate: kortHjem.getAttribute('data-rate'), post: post };
      if (postFelt) postFelt.value = post;
      tegn(valg, false);
      lagreValg(valg);
    }

    function aapneHjem(fokus) {
      if (hent()) { glem(); tomKurvValg(); }
      tegn(null, true);
      settPostMelding('', '');
      if (fokus && postFelt) {
        try { postFelt.focus({ preventScroll: true }); } catch (e) { /* eldre nettleser */ }
      }
    }

    function proevHjem() {
      var l = hent();
      var pp = l && l.mode === HJEM ? renPost(l.post) : '';
      if (pp && postOk(pp)) { velgHjem(pp); return true; }
      return false;
    }

    function sjekkPost() {
      if (!postFelt) return;
      var pp = renPost(postFelt.value);
      if (!pp) {
        settPostMelding('feil', 'Skriv inn postnummeret ditt med 4 siffer, for eksempel 7046.', false);
        return;
      }
      if (!postOk(pp)) {
        if (hent()) { glem(); tomKurvValg(); }
        tegn(null, true);
        settPostMelding('feil',
          'Beklager, vi kjører dessverre ikke hjem til ' + pp + ' ennå. Hjemlevering gjelder foreløpig bare Trondheim og omegn. ' +
          'Velg utlevering i stedet — det er gratis.', harUt);
        return;
      }
      lagreSistPost(pp);
      velgHjem(pp);
    }

    function bygHjemPanel() {
      injiserStil();
      hjemPanel = document.createElement('div');
      hjemPanel.className = 'fg-lev__post';
      hjemPanel.setAttribute('data-fg-lev-panel', 'hjem');
      hjemPanel.setAttribute('role', 'group');
      hjemPanel.setAttribute('aria-labelledby', 'fg-lev-post-tittel');
      hjemPanel.hidden = true;
      hjemPanel.innerHTML =
        '<p class="fg-lev__post-tittel" id="fg-lev-post-tittel">Sjekk her om vi leverer til deg</p>' +
        '<label class="fg-lev__post-label" for="fg-lev-postnr">Skriv inn postnummeret ditt:</label>' +
        '<div class="fg-lev__post-rad">' +
          '<span class="fg-lev__finger fg-lev__finger--hoyre" aria-hidden="true">👉</span>' +
          '<input id="fg-lev-postnr" class="fg-lev__post-felt" type="text" inputmode="numeric" autocomplete="postal-code" maxlength="8" placeholder="7046" data-fg-lev-post>' +
          '<button type="button" class="fg-lev__post-knapp" data-fg-lev-post-sjekk>Sjekk</button>' +
        '</div>' +
        '<p class="fg-lev__post-melding" data-fg-lev-post-melding role="alert"></p>' +
        '<button type="button" class="fg-lev__post-bytt" data-fg-lev-post-bytt hidden>Velg utlevering i stedet</button>';
      if (status && status.parentNode) {
        status.parentNode.insertBefore(hjemPanel, status.nextSibling);
      } else {
        kortHjem.parentNode.insertBefore(hjemPanel, kortHjem.nextSibling);
      }
      postFelt = hjemPanel.querySelector('[data-fg-lev-post]');
      postMelding = hjemPanel.querySelector('[data-fg-lev-post-melding]');
      postBytt = hjemPanel.querySelector('[data-fg-lev-post-bytt]');

      hjemPanel.querySelector('[data-fg-lev-post-sjekk]').addEventListener('click', sjekkPost);
      postFelt.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); sjekkPost(); }
      });
      postFelt.addEventListener('input', function () {
        var pp = renPost(postFelt.value);
        var naa = hent();
        var uendret = !!(naa && naa.mode === HJEM && naa.post === pp);
        if (naa && naa.mode === HJEM && !uendret) {
          glem(); tomKurvValg();
          tegn(null, true);
        }
        if (!uendret) settPostMelding('', '');
        if (pp && !uendret) sjekkPost();
      });
      /* «Velg utlevering i stedet»: rull opp til utleveringskortene. */
      postBytt.addEventListener('click', function () {
        var forste = kortUt.midt || kortUt.ost;
        if (!forste) return;
        forste.scrollIntoView({ behavior: 'smooth', block: 'center' });
        try { forste.focus({ preventScroll: true }); } catch (e) { /* eldre nettleser */ }
      });
    }

    if (kortHjem) bygHjemPanel();

    if (kortHjem) {
      kortHjem.addEventListener('click', function () {
        var naa = hent();
        if (naa && naa.mode === HJEM && postOk(naa.post)) { tegn(naa, false); return; }
        var sist = hentSistPost();
        if (sist && postOk(sist)) { velgHjem(sist); return; }
        aapneHjem(true);
      });
    }

    ['midt', 'ost'].forEach(function (ld) {
      if (!kortUt[ld]) return;
      kortUt[ld].addEventListener('click', function () {
        var naa = hent();
        if (naa && naa.mode === MODE[ld]) { tegn(naa, false); return; }
        velgUtlevering(ld, true);
      });
    });

    /* --- Startvalg ------------------------------------------------------- */
    var modeKurv = rot.getAttribute('data-valgt-mode') || '';
    var lagret = hent();
    var ldKurv = landsdelFor(modeKurv);

    if (!harUt && kortHjem) {
      if (!proevHjem()) {
        if (lagret || modeKurv) { glem(); tomKurvValg(); }
        tegn(null, true);
      }
      return;
    }
    /* Handlekurven har en gyldig utlevering med landsdel. */
    if (ldKurv && kortUt[ldKurv]) { velgUtlevering(ldKurv, false); return; }
    if (modeKurv === HJEM && kortHjem) {
      if (proevHjem()) return;
      glem(); tomKurvValg();
      tegn(null, true);
      return;
    }
    /* Ukjent/gammel verdi (f.eks. «Utlevering» uten landsdel): nullstill. */
    if (modeKurv) { glem(); tomKurvValg(); tegn(null, false); return; }
    /* Tom handlekurv-verdi: bruk lagret valg fra nettleseren hvis gyldig. */
    var ldLagret = lagret ? landsdelFor(lagret.mode) : '';
    if (ldLagret && kortUt[ldLagret]) { velgUtlevering(ldLagret, true); return; }
    if (lagret && lagret.mode === HJEM && kortHjem) {
      if (proevHjem()) return;
      glem();
      tegn(null, true);
      return;
    }
    if (lagret) glem();
    tegn(null, false);
  }

  function init() {
    oppdaterMerker(hent());
    var rot = document.querySelector('[data-fg-levering]');
    if (rot) {
      try { start(rot); } catch (e) {
        krever = false;
        if (window.console) console.error('froya-levering:', e);
      }
    }
    document.addEventListener('click', sperreKasse, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
